export const deceaseMap: GenericObject = {
	cid10: "icd",
};
